import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGS } from "@/lib/i18n";

const LangContext = createContext({ lang: "en", setLang: () => {}, dir: "ltr" });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("lal_lang") || "en";
    } catch {
      return "en";
    }
  });

  const setLang = useCallback((code) => {
    setLangState(code);
    try { localStorage.setItem("lal_lang", code); } catch { /* ignore */ }
  }, []);

  const dir = (LANGS.find((l) => l.code === lang) || LANGS[0]).dir;

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang, dir]);

  return (
    <LangContext.Provider value={{ lang, setLang, dir }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
